'use strict';

import Agency from './common/agency';

/**
 * Пользователь
 * @constructor
 * @param object
 */
function User (object) {
  this.user = object.get('author') || null;
  this.trusted = object.get('isTrusted');
  this.manageLink = object.get('manageUserLink');

  const agency = object.get('agency');
  this.agency = agency ? new Agency(agency) : null;
}

User.TYPE_ADMIN = 2;
User.TYPE_REALTOR = 0;
User.TYPE_OWNER = 3;

const proto = User.prototype;

proto.isExist = function () {
  return !!this.user;
};

proto.getId = function () {
  return this.isExist() && this.user.get('id');
};

proto.getAvatar = function () {
  return (this.isExist() && this.user.get('avatar')) || 'placeholder';
};

proto.getName = function () {
  return this.isExist() && this.user.get('fullName');
};

proto.getLogin = function () {
  return this.isExist() && this.user.get('username');
};

proto.isRealtor = function () {
  return this.isExist() && !!this.user.get('isRealtor');
};

proto.isOwner = function () {
  return parseInt((this.isExist() && this.user.get('userTypeId')) || -1) === User.TYPE_OWNER;
};

proto.isTrusted = function () {
  return this.trusted;
};

proto.getManageLink = function () {
  return this.manageLink;
};

proto.getAgency = function () {
  return this.agency;
};

export default User;



// WEBPACK FOOTER //
// ./src/classes/user.js